import { setCookie } from './functions.js';
import { getCookie } from './functions.js';
import { getUrlParameter } from './functions.js';
import { openModal } from './functions.js';
import { imageSrc } from './functions.js';

// var pop_up = script_vars.pop_up;
// var page_popup = script_vars.page_popup;
// var current_page_id = script_vars.current_page_id;
// var exclude_page_id = pop_up.exclude_page.ID;

// console.log(current_page_id);
// console.log(exclude_page_id);
// console.log(page_popup);

// console.log('excludepage id: ' + exclude_page_id);
// console.log('current page id: ' + current_page_id);


//
// Popup modal functionality
//
function popup_pestalert() {
	var pop_up = script_vars.pop_up;
	var current_page_id = script_vars.current_page_id;
	var exclude_page_id = pop_up.exclude_page;

	// console.log(pop_up);
	// console.log(current_page_id);
	// console.log(exclude_page_id);

	var popup_pestalert = document.querySelector('.popup-pestalert');
	var close = document.querySelector('.popup-pestalert .popup-close');
	var link = document.querySelector('.popup-pestalert a');
	var cookie = getCookie("popup-pestcontrol");

	// console.log(current_page_id);
	// console.log(exclude_page_id);


    // Check if the current_page_id is in the exclude_page_ids array
	if (exclude_page_id.some(page => parseInt(page.ID) === parseInt(current_page_id))) {
        console.log('disable popup');
    } else {
        console.log('enable popup');

        // check cookie
        if (cookie == null || cookie == 'false') {
            popup_pestalert.classList.add('active');
        } else {
            // Nothing
        }

        // remove active class on popup
        close.addEventListener("click", (e) => {
            popup_pestalert.classList.remove('active');
            setCookie('popup-pestcontrol', 'true', 1);
        });

        link.addEventListener("click", (e) => {
            setCookie('popup-pestcontrol', 'true', 1);
            popup_pestalert.classList.remove('active');
        });
    }
}
window.addEventListener('load', popup_pestalert);


//
// Unique page popup /w contact form
//
function popup_page() {
	var page_popup = script_vars.page_popup;

	// console.log(script_vars);

	if(page_popup) {
		var toggle = page_popup.toggle_popup;
		var contact_form_shortcode = page_popup.contact_form_shortcode;
		var popup_image = page_popup.popup_image.url;
		var url_parameter = page_popup.url_parameter;

		const parameterValue = getUrlParameter('origin');
		// console.log(parameterValue);
		// console.log(url_parameter);
		if(parameterValue == url_parameter) {
			openModal('.modal-page');
		}
	}
}
window.addEventListener('load', popup_page);

//
// Show redirect popup
//
function redirect() {
	const parameterValue = getUrlParameter('origin');
	var text = document.querySelector('.modal-redirect .text');

	if(parameterValue !== null) {
		console.log(parameterValue);
		if(parameterValue == 'terminix') {

			text.innerHTML += '<h4>We are very excited to share that from 1 August 2022, Terminix UK Ltd will be operating under the new name <a href="https://vergo.uk/">Vergo Pest Management Ltd.</a></h4>';
			text.innerHTML+= '<p>Our new brand recognises us as the UK\'s largest independent pest management provider, which is underpinned by our main shareholder and investors from Norvestor.</p>';
			text.innerHTML+= '<p>This change of company name will allow us to present ourselves as the most innovative and forward-thinking pest management business in the UK today.  As part of our new brand commitment, we will also be continuing to develop our sustainability and green credentials on behalf of our customers, staff and for future generations.</p>';
			imageSrc('/assets/images/logo-origin.svg');
			openModal('.modal-redirect');

		} else if(parameterValue == 'pestpulse') {

			text.innerHTML += '<h4>On 1 April we acquired Pest Pulse Ltd (UK only).</h4>';
			text.innerHTML += '<p>All services previously carried out by Pest Pulse are now being carried out Vergo Pest Management Ltd.</p>';
			text.innerHTML += '<p>Vergo is the largest UK’s largest independent pest management provider, and we are the most innovative and forward-thinking pest management business in the UK today.</p>';
			imageSrc('/assets/images/logo_pestcontrol.svg');
			openModal('.modal-redirect');

		} else if(parameterValue == 'expertpest') {

			text.innerHTML += '<h4>Vergo Pest Management Ltd acquire Expert Pest Control Ltd</h4>';
			text.innerHTML += '<p>We are pleased to announce the acquisition of Expert Pest Control by Vergo Pest Management Ltd, which was officially completed on Friday 30 September 2022.</p>';
			imageSrc('/assets/images/logo_pestcontrol.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'ebs') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Environmental Building Services Ltd.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Environmental Building Services (EBS) by Vergo Pest Management Ltd, which officially completed on 15 February 2023.</p>';
			imageSrc('/assets/images/logo_ebs.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'ebsbioclean') {

			text.innerHTML += '<h4>Vergo Pest Management acquire EBS Bioclean services.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of EBS Bioclean by Vergo Pest Management Ltd, which officially completed on 15 February 2023.</p>';
			imageSrc('/assets/images/logo_ebsbioclean.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'greenthink') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Greenthink Pest Control.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Greenthink Pest Control by Vergo Pest Management Ltd, which officially completed on 31 March 2023.</p>';
			imageSrc('/assets/images/logo_greenthink.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'valleypestcontrol') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Valley Pest Control.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Valley Pest Control by Vergo Pest Management Ltd, which officially completed on 1 April 2023.</p>';
			imageSrc('/assets/images/logo_valleypestcontrol.jpg');
			openModal('.modal-redirect');

		} else if(parameterValue == 'agpest') {

			text.innerHTML += '<h4>Vergo Pest Management acquire AG Pest Management Ltd.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of AG Pest Management Ltd by Vergo Pest Management Ltd which officially completed on 1 April 2023.</p>';
			imageSrc('/assets/images/logo_ag.jpg');
			openModal('.modal-redirect');

		} else if(parameterValue == 'greencare') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Green Care UK Ltd.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Green Care UK Ltd by Vergo Pest Management Ltd which officially completed on 1 April 2023.</p>';
			imageSrc('/assets/images/logo_greencare.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'rodentservices') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Rodent Service (East Anglia) Ltd.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Rodent Service (East Anglia) Ltd by Vergo Pest Management Ltd which officially completed on 18 May 2023.</p>';
			imageSrc('/assets/images/logo_rs.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'melfordenvironmentalservices') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Melford Environmental Services Ltd.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Melford Environmental Services Ltd by Vergo Pest Management Ltd which officially completed on 20 December 2023.</p>';
			imageSrc('/assets/images/logo_melford.png');
			openModal('.modal-redirect');

		} else if(parameterValue == 'bustersgroup') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Busters Group.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Busters Group Ltd by Vergo Pest Management Ltd. This includes Pest Busters, Total Bird Control, Garden Busters, Total Property Clearance and Hygiene Busters.</p>';
			imageSrc('/assets/images/logo_bustersgroup.jpg');
			openModal('.modal-redirect');

		} else if(parameterValue == 'pro-active') {

			text.innerHTML += '<h4>Vergo Pest Management acquire Pro-active Pest Management Services Ltd.</h4>';
			text.innerHTML+= '<p>We are pleased to announce the acquisition of Pro-active Pest Management Services Ltd by Vergo Pest Management Ltd.</p>';
			imageSrc('/assets/images/logo_ppms.png');
			openModal('.modal-redirect');

		}

	} else {
		// console.log('no origin');
	}
}
window.addEventListener('load', redirect);


function toggleChatbot() {
    const chatbotButton = document.querySelector('#chatbot-button');
    const chatbotContainer = document.querySelector('#chatbot-container');
    const chatbotClose = document.querySelector('#chatbot-container__close');

    if (!chatbotButton || !chatbotContainer) {
        console.error('Chatbot elements not found in the DOM');
        return;
    }

    // Initially hide the chatbot
    chatbotContainer.style.display = 'none';

    chatbotButton.addEventListener('click', () => {
        console.log('Chatbot button clicked');

        // Toggle the visibility of the chatbot container
        if (chatbotContainer.style.display === 'none') {
            chatbotContainer.style.display = 'block';
        } else {
            chatbotContainer.style.display = 'none';
        }
    });

    chatbotClose.addEventListener('click', () => {
        console.log('Chatbot close button clicked');
        // Hide the chatbot container
        chatbotContainer.style.display = 'none';
    });
}

// Call the function when DOM is fully loaded
document.addEventListener('DOMContentLoaded', toggleChatbot);
